/**
 * Forms Inputs Validations
 */

// Inputs validations Maps

const REQUIRED_VALIDATIONS_COUNTRY_MAP = {
  sg: 'This field is required.',
  c2: '此字段是必需的。',
  jp: 'この項目は必須です。'
};

const NAME_VALIDATIONS_COUNTRY_MAP = {
  sg: 'Enter a valid name.',
  c2: '输入有效的名称。',
  jp: '有効な名前を入力してください'
};

const PHONE_NUMBER_VALIDATIONS_COUNTRY_MAP = {
  sg: 'This field is required',
  c2: '请输入您的电话号码',
  jp: '正しくビジネス用の電話番号を入力してください'
};

const EMAIL_VALIDATIONS_COUNTRY_MAP = {
  sg: 'This field is required.',
  c2: '请输入您的邮件地址',
  jp: '正しくメールアドレス入力してください'
};
// Get Validation Object Utils
const getRequiredValidationObj = ({ country, errorMessage }) => ({
  rule: 'required',
  errorMessage: errorMessage
    ? errorMessage
    : REQUIRED_VALIDATIONS_COUNTRY_MAP[country.toLowerCase()],
});
const getNameValidationObj = ({ country }) => ({
  rule: 'input-type',
  inputType: 'name',
  errorMessage: NAME_VALIDATIONS_COUNTRY_MAP[country.toLowerCase()],
});

const getPhoneNumberValidationObj = ({ country }) => ({
  rule: 'input-type',
  inputType: 'phone-number',
  errorMessage: PHONE_NUMBER_VALIDATIONS_COUNTRY_MAP[country.toLowerCase()],
});

const LENGTH_VALIDATIONS_COUNTRY_MAP = {
  sg: 'The max length for this field is {{value}}.',
  c2: '该字段的最大长度为 {{value}}。',
  jp: 'このフィールドの最大長は次のとおりです {{value}}'
};
const getLengthValidationObj = ({ country, value }) => {
  const errorMessageTemplate =
    LENGTH_VALIDATIONS_COUNTRY_MAP[country.toLowerCase()];

  if (errorMessageTemplate !== undefined) {
    const errorMessage = errorMessageTemplate.replace('{{value}}', value);
    return {
      rule: 'input-type',
      inputType: 'min-length',
      value,
      errorMessage,
    };
  } else {
    return 'Country not supported';
  }
};

const getEmailValidationObj = ({ country, inputType }) => ({
  rule: 'input-type',
  inputType,
  errorMessage: EMAIL_VALIDATIONS_COUNTRY_MAP[country.toLowerCase()],
});

export {
  getRequiredValidationObj,
  getLengthValidationObj,
  getEmailValidationObj,
  getNameValidationObj,
  getPhoneNumberValidationObj,
};
